/**
 * Stringify an object into a query string.
 * Supports excluding specific keys.
 * @param {object} object
 * @param {{ exclude: string[] }} options
 * @returns {string}
 * @example
 * const queryStringA = createQueryString({foo: 0}) // 'foo=0'
 * const queryStringB = createQueryString({foo: 0}, {exclude: 'foo'}) // ''
 */
export default function createQueryString(object = {}, options = {exclude: []}) {
	// remove undefined values from object
	object = Object.fromEntries(Object.entries(object).filter(entry => entry[1] !== undefined))

	const urlSearchParams = new URLSearchParams(object)
	options.exclude.forEach(key => urlSearchParams.delete(key))

	let queryString = urlSearchParams.toString()
	if (queryString.length) queryString = '?' + queryString
	return queryString
}
